import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Authentication from './pages/authentication';
import AdminDashboard from './pages/admin-dashboard';
import LandingPage from './pages/landing-page';
import AnalysisDetail from './pages/analysis-detail';
import Dashboard from './pages/dashboard';
import SearchResults from './pages/search-results';
import ListingDetail from './pages/listing-detail';
import CreateListingWizard from './pages/create-listing-wizard';
import JoinAsPro from './pages/join-as-pro';
import MortgageCheck from './pages/mortgage-check';
import PropertyComparison from './pages/property-comparison';
import FairPriceAnalysis from './pages/fair-price-analysis';
import RiskAssessment from './pages/risk-assessment';
import OfferRangeGuidance from './pages/offer-range-guidance';
import AgentQuestions from './pages/agent-questions';
import Reports from './pages/reports';
import History from './pages/history';
import ListYourPropertyLanding from './pages/list-your-property-landing';
import AgentDashboard from './pages/agent-dashboard';
import BulkUploadProperties from './pages/bulk-upload-properties';
import ProfessionalMarketplace from './pages/professional-marketplace';
import JoinAsProfessional from './pages/join-as-professional';
import ProfessionalProfile from './pages/professional-profile';
import ConsultationBookingConfirmation from './pages/consultation-booking-confirmation';
import RERAComplianceIntelligence from './pages/rera-compliance-intelligence';
import OffPlanAnalyticsROI from './pages/off-plan-analytics-roi';
import ExpatBuyerGuidance from './pages/expat-buyer-guidance';
import UAEMortgageFinance from './pages/uae-mortgage-finance';
import DubaiAbuDhabiDeepdive from './pages/dubai-abu-dhabi-deepdive';
import All7Emirates from './pages/all-7-emirates';
import UAEMarketIntelligenceReports from './pages/uae-market-intelligence-reports';
import BangladeshMarketIntelligenceReports from './pages/bangladesh-market-intelligence-reports';
import RAJUKComplianceIntelligence from './pages/rajuk-compliance-intelligence';
import AboutUs from './pages/about-us';
import PrivacyPolicy from './pages/privacy-policy';
import TermsOfService from './pages/terms-of-service';
import ContactUs from './pages/contact-us';
import FAQ from './pages/faq';
import HelpSupport from './pages/help-support';
import NotFoundErrorPage from './pages/404-error-page';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/authentication" element={<Authentication />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/analysis-detail" element={<AnalysisDetail />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/search-results" element={<SearchResults />} />
        <Route path="/listing/:id" element={<ListingDetail />} />
        <Route path="/listing-detail" element={<ListingDetail />} />
        <Route path="/create-listing" element={<CreateListingWizard />} />
        <Route path="/create-listing-wizard" element={<CreateListingWizard />} />
        <Route path="/join-as-pro" element={<JoinAsPro />} />
        <Route path="/mortgage-check" element={<MortgageCheck />} />
        <Route path="/property-comparison" element={<PropertyComparison />} />
        <Route path="/fair-price-analysis" element={<FairPriceAnalysis />} />
        <Route path="/risk-assessment" element={<RiskAssessment />} />
        <Route path="/offer-range-guidance" element={<OfferRangeGuidance />} />
        <Route path="/agent-questions" element={<AgentQuestions />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/history" element={<History />} />
        <Route path="/list-your-property-landing" element={<ListYourPropertyLanding />} />
        <Route path="/agent-dashboard" element={<AgentDashboard />} />
        <Route path="/bulk-upload-properties" element={<BulkUploadProperties />} />
        <Route path="/professional-marketplace" element={<ProfessionalMarketplace />} />
        <Route path="/join-as-professional" element={<JoinAsProfessional />} />
        <Route path="/professional-profile" element={<ProfessionalProfile />} />
        <Route path="/consultation-booking-confirmation" element={<ConsultationBookingConfirmation />} />
        <Route path="/rera-compliance-intelligence" element={<RERAComplianceIntelligence />} />
        <Route path="/off-plan-analytics-roi" element={<OffPlanAnalyticsROI />} />
        <Route path="/expat-buyer-guidance" element={<ExpatBuyerGuidance />} />
        <Route path="/uae-mortgage-finance" element={<UAEMortgageFinance />} />
        <Route path="/dubai-abu-dhabi-deepdive" element={<DubaiAbuDhabiDeepdive />} />
        <Route path="/all-7-emirates" element={<All7Emirates />} />
        <Route path="/uae-market-intelligence-reports" element={<UAEMarketIntelligenceReports />} />
        <Route path="/bangladesh-market-intelligence-reports" element={<BangladeshMarketIntelligenceReports />} />
        <Route path="/rajuk-compliance-intelligence" element={<RAJUKComplianceIntelligence />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/help" element={<HelpSupport />} />
        <Route path="/help-support" element={<HelpSupport />} />
        <Route path="/404-error-page" element={<NotFoundErrorPage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
